<template>
  <v-row style="height: 700px">
      <v-progress-linear style="position: relative;" v-if="loading" indeterminate color="primary"></v-progress-linear>
    <l-map
      ref="map"
      class="map"
      @click="onMapClick"
      style="position: initial;"
      :center="[geoLat, geoLon]"
      :options="{ zoomControl: false, attributionControl: false }"
      :zoom="zoom"
    >
      <div style="padding-bottom: 20px">
        <l-control-zoom
          position="topleft"
          zoom-in-text="<i style='color: black;'>+</i>"
          zoom-out-text="<i style='color: black;'>-</i>"
        >
        </l-control-zoom>
      </div>
      <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <vue2-leaflet-marker-cluster
        :options="optionsMarkerCluster"
        @clusterclick="onClusterClick"
      >
        <div v-if="loading">
        </div>
        <div v-else>
          <div v-for="(item, index) in filteredDevices" :key="index">
            <l-marker :lat-lng="[item.geo_lat, item.geo_lon]" :draggable="false">
              <marker-cluster-map
                :item="item"
                :lastUserMarker="lastUserMarker">
              </marker-cluster-map>
            </l-marker>
          </div>
        </div>
      </vue2-leaflet-marker-cluster>
      <l-polygon :lat-lngs="resComplexPolygons.coordinates" :options="polygonOptions" class="custom-polygon">
        <l-tooltip>Жилой комплекс: {{ resComplexPolygons.name }}</l-tooltip>
      </l-polygon>
    </l-map>
    <div
      class="btn-add-marker mr-3"
         v-if="disableRoleName &&
         Array.isArray(doorphones.barriers) &&
         doorphones.barriers.length > 0">
      <v-btn
        @click="dialogChangeCoordinates = true"
        class="text-none mb-2"
        color="medium-emphasis"
        rounded
        :loading="loading"
        :disabled="isAddingMarker"
      >
        Изменить координаты шлагбаумов
      </v-btn>
      <v-btn @click="cancelMarker" class="text-none mb-2" color="medium-emphasis" rounded v-if="isAddingMarker">
        Отменить изменения
      </v-btn>
      <v-btn @click="saveMarker" class="text-none" color="primary" rounded v-if="isAddingMarker">
        Сохранить
      </v-btn>
      <add-marker
        :dialog="dialogChangeCoordinates"
        :is-adding-marker="isAddingMarker"
        :searchDooprhone="searchBarrier"
        @startAddingMarker="startAddingMarker"
        @searchAddressDoorphone="searchAddressBarrier"
        @update="updateMap"
        @close="dialogChangeCoordinates = false"
      >
      </add-marker>
    </div>
    <div>
      <search-map
        v-if="!loading && this.attachedDoorphones[0]"
        class="search-map-individual"
        textPlaceholder="Введите адрес"
        :is-disabled="false"
        @searchAddress="searchAddress"
      >
      </search-map>
    </div>
  </v-row>
</template>

<script>
import { LMap, LMarker, LControlZoom, LTileLayer, LPolygon, LTooltip } from 'vue2-leaflet';
import markerClusterMap from '../../../components/complexesMap/MarkerClusterMap';
import searchMap from '../../../components/complexesMap/SearchMap';
import addMarker from '../../../components/complexesMap/AddMarker';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import { mapActions, mapGetters } from 'vuex';
import { divIcon } from 'leaflet';

export default {
  name: 'ResidentialComplexesIndividual',
  props: ['id'],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LTooltip,
    Vue2LeafletMarkerCluster,
    markerClusterMap,
    LControlZoom,
    searchMap,
    addMarker,
  },
  data () {
    return {
      polygonOptions: {
        color: '#fa6674',
        fillColor: '#262121',
        fillOpacity: 0.1,
      },
      resComplexPolygons: {},
      attachedDoorphones: [],
      disableRoleName: false,
      searchValue: '',
      isAddingMarker: false,
      isAddMarker: false,
      geoLat: '54.318',
      selectedBarrier: {},
      dialogChangeCoordinates: false,
      isSearchMapDisabled: false,
      geoLon: '48.384',
      dialog: false,
      loading: false,
      filterType: '',
      filterAddress: '',
      zoom: 13,
      center: [54.318607, 48.397819],
      lastUserMarker: {},
      optionsMarkerCluster: {
        showCoverageOnHover: false,
        removeOutsideVisibleBounds: true,
        singleMarkerMode: false,
        zoomToBoundsOnClick: false,
        maxClusterRadius: 50,
        spiderLegPolylineOptions: {
          color: 'transparent',
        },
        iconCreateFunction: this.customIconCreateFunction,
      },
    };
  },
  async created () {
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.disableRoleName = true;
        break;
    }
    this.loading = true;
    await this.getResidentialComplex(this.$route.params.id)
      .then((data) => {
        this.resComplexPolygons = data;
        this.attachedDoorphones = this.resComplexPolygons.doorphones.map(doorphone => doorphone.id);
        this.attachedBarriers = this.resComplexPolygons.barriers.map(doorphone => doorphone.id);
        if (!this.attachedBarriers.length) {
          this.attachedBarriers = [-1];
        }
        const allIds = [...this.attachedDoorphones, ...this.attachedBarriers];

        if (allIds.length > 0) {
          this.getDoorphonesByIds(this.attachedDoorphones, this.attachedBarriers);
        } else {
          const originCoordinatesResComplex = this.resComplexPolygons.coordinates[0];
          this.isThereAttachedDoorphones = true;
          this.geoLat = originCoordinatesResComplex[0];
          this.geoLon = originCoordinatesResComplex[1];
          this.loading = false;
          this.$flash_danger('Нет привязанных домофонов');
        }
      });
  },
  methods: {
    ...mapActions({
      getMapDoorphones: 'Doorphone/getMapDoorphones',
      getResidentialComplex: 'ResidentComplex/viewComplex',
      updateCoordsBarrier: 'Barriers/updateCoordsBarrier',
    }),
    onMapClick (event) {
      if (this.isAddingMarker) {
        const { lat, lng } = event.latlng;
        const barriers = this.doorphones.barriers;
        const isOnMap = barriers.find(doorphone => doorphone.id === this.selectedBarrier.id);
        if (isOnMap) {
          this.removedMarker = this.selectedBarrier;
          this.$store.commit('removeMarker', isOnMap);
        }
        if (this.lastUserMarker) {
          this.$store.commit('removeMarker', this.lastUserMarker);
        }
        const newMarker = {
          id: this.selectedBarrier.id,
          address: this.selectedBarrier.address,
          snapshot: this.selectedBarrier.snapshot,
          type: 'B',
          geo_lat: lat,
          geo_lon: lng,
        };
        this.lastUserMarker = newMarker;
        this.$store.commit('addDoorphone', newMarker);
      }
    },
    searchAddressBarrier (addressBarrier) {
      this.searchValue = addressBarrier;
    },
    updateMap () {
      this.center = [54.318607, 48.397819];
      this.zoom = 12;
    },
    async saveMarker () {
      this.isAddingMarker = false;
      this.isAddMarker = false;
      const tempBarrier = {
        geo_lat: this.lastUserMarker.geo_lat,
        geo_lon: this.lastUserMarker.geo_lon,
      };
      await this.updateCoordsBarrier({
        id: this.selectedBarrier.id,
        barrier: tempBarrier,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
          this.isSearchMapDisabled = false;
          this.getDoorphonesByIds(this.attachedDoorphones, this.attachedBarriers);
        })
        .catch((message) => {
          this.cancelMarker();
          this.$flash_warning('Ошибка при изменении информации');
        });
    },
    async cancelMarker () {
      this.isAddingMarker = false;
      this.polygonStatesshowPopup = false;
      this.isSearchMapDisabled = false;
      this.isAddMarker = false;
      if (this.lastUserMarker) {
        this.$store.commit('removeMarker', this.lastUserMarker);
      }
      if (this.removedMarker) {
        this.$store.commit('addDoorphone', this.removedMarker);
      }
      this.removedMarker = null;
      this.lastUserMarker = {};
      this.$flash_danger('Изменения отменились');
    },
    startAddingMarker (item) {
      this.isAddingMarker = true;
      this.isSearchMapDisabled = true;
      this.isAddMarker = true;
      this.dialogChangeCoordinates = false;
      this.selectedBarrier = item;
    },
    searchAddress (address, selectedTypes) {
      this.filterAddress = address;
      this.filterType = selectedTypes;
      let doorphones;
      if (this.doorphones) {
        doorphones = this.doorphones.doorphones.concat(this.doorphones.barriers);
      }

      if (address) {
        doorphones = doorphones.filter((doorphone) =>
          doorphone.address.toLowerCase().includes(address.toLowerCase()),
        );
      }
      if (selectedTypes) {
        doorphones = doorphones.filter((doorphone) =>
          selectedTypes.some((selectedType) =>
            doorphone.type &&
            doorphone.type.toLowerCase().includes(selectedType.toLowerCase()),
          ),
        );
      }

      if (address && doorphones.length > 0) {
        this.center = [doorphones[0].geo_lat, doorphones[0].geo_lon];
        this.zoom = 13;
      }
    },
    onClusterClick (a) {
      if (this.$refs.map && this.$refs.map.mapObject) {
        this.$refs.map.mapObject.fitBounds(a.layer.getBounds().pad(0.5));
      }
    },
    customIconCreateFunction (cluster) {
      const childCount = cluster._childCount;
      const firingCount = cluster._firingCount;

      let className = 'custom-cluster-icon';
      if (childCount < 10) {
        className += ' custom-cluster-icon-small';
      } else if (childCount < 100) {
        className += ' custom-cluster-icon-medium';
      } else {
        className += ' custom-cluster-icon-large';
      }
      if (firingCount && firingCount === 0) {
        className += ' custom-cluster-icon-none';
      }
      return divIcon({
        html: `<div class='${className}'><span>${childCount}</span></div>`,
        className,
      });
    },
    async getDoorphonesByIds (doorphoneId, barrierId) {
      const filters = {};

      filters.doorphone_id = doorphoneId.length ? doorphoneId : [-1];
      if (barrierId.length) {
        filters.barrier_id = barrierId;
      }

      await this.getMapDoorphones({ filters })
        .then(() => {
          this.setMapCenter();
        })
        .catch(() => {
          this.$flash_warning('Произошла ошибка загрузки карты');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setMapCenter () {
      const { doorphones, barriers } = this.doorphones;

      if (doorphones.length) {
        this.geoLat = doorphones[0].geo_lat;
        this.geoLon = doorphones[0].geo_lon;
      } else if (barriers.length) {
        this.geoLat = barriers[0].geo_lat;
        this.geoLon = barriers[0].geo_lon;
      } else {
        this.geoLat = 54.318;
        this.geoLon = 48.384;
      }
    },
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      doorphones: 'Doorphone/mapDoorphones',
    }),
    filteredDevices () {
      let doorphones = [...this.doorphones.doorphones, ...this.doorphones.barriers];

      if (this.filterAddress) {
        doorphones = doorphones.filter((doorphone) =>
          doorphone.address.toLowerCase().includes(this.filterAddress.toLowerCase()),
        );
      }

      if (this.filterType) {
        doorphones = doorphones.filter((doorphone) =>
          this.filterType.some((selectedType) =>
            doorphone.type &&
            doorphone.type.toLowerCase().includes(selectedType.toLowerCase()),
          ),
        );
      }

      return doorphones;
    },
    searchBarrier () {
      let barriers = [];

      if (this.doorphones.barriers.length > 0) {
        barriers = this.doorphones.barriers;
      }

      if (this.searchValue) {
        barriers = barriers.filter(doorphone => {
          return doorphone.address.toString().toLowerCase().includes(this.searchValue.toLowerCase()) ||
            doorphone.id.toString().toLowerCase().includes(this.searchValue.toLowerCase());
        });
      }

      return barriers;
    },
  },
};
</script>

<style lang="scss">
@import '../../../components/complexesMap/TheMap.scss';
.map {
  position: initial;
  height: 100%;
}
.btn-add-marker {
  position: absolute;
  display: grid;
  top: 20px;
  right: 22%;
  z-index: 9999;
}
.search-map-individual {
  z-index: 9999;
  top: 20px;
  right: 25px;
}
.v-card__text, .v-card__title {
  word-break: normal;
}
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
@media screen and (max-width: 1550px) {
  .btn-add-marker {
    top: 205px;
    right: 3%;
    z-index: 0;
  }
  .is-active-btn-add-marker {
    top: 405px
  }
}
@media screen and (max-width: 550px) {
  .search-map-individual {
    top: 15px;
    right: 10px;
  }
}
</style>
